<template>
  <el-card
    class="background"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="deposit-audit">
      <SiruiSearch
        ref="searchRef"
        :query="queryData"
        :columns="topColumns"
        :isQueryPanel="true"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="searchTrigger"
        @changeMethod="changeMethod"
      ></SiruiSearch>
      <div class="result-table">
        <sirui-table
          ref="siruiTable"
          :buttonList="menuButtonList"
          @chooseClick="chooseClick"
          :loading="loading"
          @handleSelectionChange="handleSelectionChange"
          @handleSizeChange="() => getDetailtMgtList()"
          @handleCurrentChange="() => getDetailtMgtList()"
          :data="tableData"
          :paging="true"
          :setting="false"
          :customVisible="false"
          :columns="tableColumns"
          :spanMethod="mergeRowMethod"
          :cellClick="cellClick"
          :cellStyle="cellStyle"
          :footerMethod="footerTotalCols ? footerMethodTotal : null"
          :showFooter="true"
        >
          <vxe-table-column type="checkbox" width="50"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in tableColumns"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template slot-scope="scope">
              <span v-if="item.field == 'contractType'">
                {{ getColumnName('contractType', scope.row[item.field]) }}</span
              >
              <span v-else-if="item.field == 'leaseDuration'">
                {{ getLeaseDuration(scope.row) }}</span
              >
              <span v-else-if="item.field == 'contractStatus'">
                {{ getColumnName('contractStatus', scope.row[item.field]) }}</span
              >
              <span v-else>{{ scope.row[item.field] }}</span>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
      <PrintSetupDialog
        ref="depositActionDialogRef"
        :searchData="queryData"
        @handleSure="() => handleSure()"
        :key="dateKey"
      ></PrintSetupDialog>
    </div>
  </el-card>
</template>

<script>
  import DEPOSITAPI from '@/api/reportManagement';
  import API from '@/api/property/meterManagement';
  import { searchColumns, defaultTableColumns } from './columns';
  import ReportMixin from './mixins/reportMixin';
  import PrintSetupDialog from './printSetupDialog';
  export default {
    name: 'detailAccount1',
    mixins: [ReportMixin],
    components: {
      PrintSetupDialog,
    },
    async mounted() {
      this.queryData.contractCompanyNo = this.userInfo.companyCode;
      await this.department(this.userInfo.companyCode);
      this.queryData.contractDepartmentNo = this.userInfo.departmentCode;
      // this.queryData.receivableAccountPeriod = moment(new Date()).format('yyyy-MM');
      this.$refs.siruiTable.setPageSize(10);
      await this.querySpaceTree();
      await this.getDetailtMgtList();
      await this.getButtonList();
    },
    data() {
      return {
        loading: false,
        tableColumns: [],
        menuButtonList: [], // 表格功能按钮
        value: null,
        treeData: [],
        tableData: [],
        copyTableData: [],
        dateKey: Date.now(),
        queryData: {
          contractCompanyNo: null,
          contractDepartmentNo: null,
          spaceAssetId: null,
          receivableAccountPeriod: null,
          customerName: null,
          contractNo: null,
          expenseType: null,
        },
        footerTotalCols: {
          amount: [
            'beginPeriodNotReceived',
            'currentReceivables',
            'totalReceivables',
            'currentReceived',
            'totalReceived',
            'finalNotReceived',
          ],
          quantity: [],
        },
      };
    },
    computed: {
      topColumns() {
        return searchColumns(this);
      },
    },
    created() {
      let params = this.$route.params;
      if (params && params.expenseType) {
        this.queryData.expenseType = [params.expenseType];
      }
      if (params && params.expenseType1) {
        this.queryData.expenseType = params.expenseType1;
      }
      if (params && params.customerName) {
        this.queryData.customerName = params.customerName;
      }
      if (params && params.contractCompanyNo) {
        this.queryData.contractCompanyNo = params.contractCompanyNo;
      }
      if (params && params.contractDepartmentNo) {
        this.queryData.contractDepartmentNo = params.contractDepartmentNo;
      }
    },
    methods: {
      footerMethodTotal({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            for (let key in this.footerTotalCols) {
              if (this.footerTotalCols[key].includes(column.property)) {
                let total = this.$utils.calSum(data, column.property);
                let point = this.$globalVar.aPoint;
                if (key == 'quantity') {
                  point = this.$globalVar.qPoint;
                }
                total = this.$utils.commafy(this.$utils.toNumber(total).toFixed(point), point);
                return total;
              }
            }
          }),
        ];
      },
      // 表格合并行
      // mergeRowMethod({ rowIndex, columnIndex }) {
      //   switch (
      //     columnIndex // 将列索引作为判断值
      //   ) {
      //     case 0:
      //       return this.mergeCol('contractNo', rowIndex, this.tableData);
      //     case 1:
      //       return this.mergeCol('contractNo', rowIndex, this.tableData);
      //     case 2:
      //       return this.mergeCol('customerName', rowIndex, this.tableData);
      //     case 3:
      //       return this.mergeCol('spaceAssetName', rowIndex, this.tableData);
      //     // case 4:
      //     //   return this.mergeRowMethod1('spaceAssetName', rowIndex, this.tableData);
      //   }
      // },
      mergeRowMethod({ row, $rowIndex, column, data, columnIndex }) {
        let fields = ['contractNo', 'customerName', 'spaceAssetName'];
        let cellValue = row[column.property];
        if (columnIndex === 0) {
          let prevRow = data[$rowIndex - 1];
          let nextRow = data[$rowIndex + 1];
          if (prevRow && prevRow['contractNo'] === data[$rowIndex]['contractNo']) {
            return { rowspan: 0, colspan: 0 };
          } else {
            let countRowspan = 1;
            while (nextRow && nextRow['contractNo'] === data[$rowIndex]['contractNo']) {
              nextRow = data[++countRowspan + $rowIndex];
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 };
            }
          }
        }
        if (cellValue && fields.includes(column.property)) {
          let prevRow = data[$rowIndex - 1];
          let nextRow = data[$rowIndex + 1];
          if (prevRow && prevRow[column.property] === cellValue) {
            return { rowspan: 0, colspan: 0 };
          } else {
            let countRowspan = 1;
            while (nextRow && nextRow[column.property] === cellValue) {
              nextRow = data[++countRowspan + $rowIndex];
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 };
            }
          }
        }
      },
      //获取空间tree
      async querySpaceTree() {
        let personCompanyCode = this.userInfo.companyCode;
        if (personCompanyCode == null || personCompanyCode == '') {
          return;
        }
        this.loading = true;
        let obj = {
          spaceCompanyNo: personCompanyCode,
          auditStatus: '03',
          isEnabled: 1,
        };
        this.$axios.post(API.AREA_TREE, obj).then((res) => {
          if (res.data.code == '0') {
            this.dataStructure(res.data.data);
            console.log(this.treeData, '树形结构数据1111');
            this.queryData.spaceAssetId = this.treeData.toString();
            this.getDetailtMgtList();
          }
        });
      },
      dataStructure(data) {
        if (data.children && data.children.length) {
          data.children.forEach((item) => {
            this.dataStructure(item);
          });
        } else {
          this.treeData.push(data.id);
        }
      },
      // 获取列表
      async getDetailtMgtList() {
        let params = { ...this.queryData };
        //暂时转换
        params.spaceAssetId = params.spaceAssetId ? params.spaceAssetId.split(',') : [];
        params.pageNum = this.$refs.siruiTable.page.pageNum;
        params.pageSize = this.$refs.siruiTable.page.pageSize;
        params = this.filterEmpty(params);
        this.loading = true;
        const { data } = await this.$axios.post(DEPOSITAPI.DETAIL_ACCOUNT_LIST, params);
        if (data && data.data && data.code == 0) {
          console.log('depositRes', data);
          this.tableData = data.data.records || [];
          this.copyTableData = JSON.parse(JSON.stringify(data.data.records));
          let list = this.tableStructure(data.data.records);
          this.tableData = list;

          this.$refs.siruiTable.setPageTotal(data.data.total);
          this.$refs.siruiTable.setPageSize(data.data.size);
        } else {
          this.$message.error(data.msg);
        }
        // //清空选择fixme
        this.selectedItems = [];
        this.loading = false;
      },
      handleSure() {
        console.log(1111, '000');
        // this.$router.go(0);
        this.$router.push('/reportManagement/detailAccount1');
        this.resetBtnClick();
      },
      async resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.selectedItems = [];
        this.queryData.contractCompanyNo = this.userInfo.companyCode;
        await this.department(this.userInfo.companyCode);
        this.queryData.contractDepartmentNo = this.userInfo.departmentCode;
        // this.queryData.receivableAccountPeriod = moment(new Date()).format('yyyy-MM');
        this.queryData.spaceAssetId = this.treeData.toString();
        this.dateKey = Date.now();
        this.getDetailtMgtList();
      },
      handleSelectionChange(row) {
        this.selectedItems = row;
      },
      // 搜索
      searchTrigger() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getDetailtMgtList();
      },

      // 表格上面的按钮
      async chooseClick(type) {
        let empty = !this.selectedItems || !this.selectedItems.length;
        if (empty && type != 'export') {
          this.$message.error('请选择数据！');
          return;
        }
        // if (!justOne && type != 'export') {
        //   this.$message.error('请选择一条数据！');
        //   return;
        // }
        switch (type) {
          case 'print':
            this.$refs.depositActionDialogRef.openDialog(this.selectedItems);
            break;
          case 'export':
            this.handleExport(this.selectedItems);
            break;
          default:
            break;
        }
      },
      async handleExport(items) {
        console.log('export', items, this.queryData);
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        let params = { ...this.queryData, pageNum, pageSize };
        params.spaceAssetId = params.spaceAssetId ? params.spaceAssetId.split(',') : [];
        const ids = [];
        if (items.length) {
          if (params.contractNo) {
            delete params.contractNo;
          }
          if (params.customerName) {
            delete params.customerName;
          }
          items.forEach((item) => {
            ids.push(item.contractNo);
          });
          params.contractNoList = ids;
        }
        let api = DEPOSITAPI.DETAIL_EXPORT;
        this.$axios.post(api, params).then((res) => {
          console.log(res, 'export res');
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //获取当前列数据
      getColumnInfo() {
        this.getColumnList(defaultTableColumns()).then(() => {
          this.tableColumns = defaultTableColumns();
        });
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          console.log('menuButtons', this.menuButtonList);
          this.getColumnInfo();
        });
      },
      cellStyle({ column }) {
        if (column.property == 'contractNo') {
          return {
            color: '#009fcc',
          };
        }
      },
      cellClick(val) {
        if (val.column?.property == 'contractNo') {
          this.handleContractDetail(val.row);
        }
      },
      handleContractDetail(row) {
        console.log(row, '跳转合同详情');
        const path = {
          path: 'propert/detailLeaseContract',
          name: 'detailLeaseContract',
          meta: {
            keepAlive: true,
            title: '租赁合同详情',
          },
          query: {
            type: 'detail',
            contractNo: row.contractNo,
          },
        };
        this.$router.push(path);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
